import {
  MediaQueries,
  Spacing
} from 'UI'

export default theme => ({
  ObjectivesGroup: {
    padding: () => Spacing(7),
    background: theme.neutral[0],
    margin: () => Spacing(0, 0, 11, 0),
    borderRadius: 8,
    position: 'relative'
  },
  shadow: {
    flex: 1
  },
  controller: {
    justifyContent: 'flex-start',
    margin: '16px 0 0 0'
  },
  core: {
    position: 'relative',
    zIndex: 1
  },
  motif1: {
    position: 'absolute',
    top: 0,
    left: 20,
    height: 77,
    width: 64,
    borderBottomLeftRadius: 32,
    borderBottomRightRadius: 32,
    opacity: 0.05,
    backgroundColor: theme.primary[0]
  },
  motif2: {
    position: 'absolute',
    top: 0,
    right: 270,
    height: 82,
    width: 100,
    borderBottomLeftRadius: 50,
    borderBottomRightRadius: 50,
    backgroundColor: theme.secondary[0]
  },
  motif3: {
    position: 'absolute',
    bottom: 0,
    right: 132,
    height: 54,
    width: 36,
    borderTopLeftRadius: 18,
    borderTopRightRadius: 18,
    backgroundColor: theme.primary[0]
  },
  motif4: {
    position: 'absolute',
    bottom: 0,
    right: 51,
    height: 320,
    width: 100,
    borderTopLeftRadius: 50,
    borderTopRightRadius: 50,
    opacity: 0.05,
    backgroundColor: theme.primary[0]
  },
  view: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    gap: 26
  },
  [`${MediaQueries.tablet}`]: {
    view: {
      gap: 16
    }
  },
  [`${MediaQueries.mobile}`]: {
    view: {
      gap: 16
    }
  }
})
